import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { AlertData, DriverData, UserData, vehicleData, VendorData } from 'src/app/Pages/sosalert/alert.data';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { Router } from '@angular/router';
import { S3BudgetService } from 'src/app/Services/s3Budget.service';
import { LoaderService } from 'src/app/Services/loader.service';

@Component({
  selector: 'app-sos-list',
  templateUrl: './sos-list.component.html',
  styleUrls: ['./sos-list.component.css']
})
export class SosListComponent implements OnInit {

  public activeTable = 'pendingAction';
  public userData;
  public tableShow: boolean = false;
  public swalFunction : any={};
  public sosID;
  public searchedValue = '';
  public currentDate = new Date();
  public filterTimeStamp = 0;

  public listActionSosData = [];
  public sosData = [];
  public noDataFoundEnable: boolean = false;
  public excelData = {};
  public pendingActionCount = 0;
  public actionTakenCount = 0;

  public closeInfoPopup: boolean = true;
  public singleSosData: any = {};
  public sosInfoPopup: boolean = true;

  public closeTakeAction: boolean = true;
  public takeActionPopup: boolean = true;

  constructor(public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public excel: ExcelExportService,
    public comService: CommonServices,
    public fb: FormBuilder,
    public router: Router,
    private store: StorageService,
    private loader: LoaderService,
    private s3AudioService: S3BudgetService,
  ) {
    this.userData = this.storage.get('userInfo',)
  }

  ngOnInit(): void {
    this.getSOSActionList();
  }

  getSOSActionList() {
    let obj = {
      actionMessage: this.activeTable == 'actionTaken',
    };
    this.api.getSosAlerts(obj).then(async (res: any) => {
      if (res.status == 'success') {
        if (this.activeTable == 'actionTaken') {
          this.listActionSosData = [];
          if (res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              let item = res.data[i];
              let obj = {
                actionMessage: item.actionMessage,
                actionTime: item.actionTime,
                date: item.gpsTS,
                employeeName: item.employeeName,
                isMobile: item.isMobile,
                empID: item.empID,
                lat: +parseFloat(item.lat).toFixed(5),
                lng: +parseFloat(item.lng).toFixed(5),
                location: item.near,
                orgID: item.org,
                sosID: item.sosID,
                sosAudio: item.sosAudio,
                type: item.type,
                vehId: item.regNo,
                //actionTimeWithin:this.different_hours(item.actionTime,item.date),
              };
              if (obj['sosAudio'] && obj['sosAudio'].length > 0) {
                for (let i = 0; i < obj['sosAudio'].length; i++) {
                  let resultAudio = await this.s3AudioService.s3GetAudio(obj['sosAudio'][i]);
                  obj['sosAudio'][i] = resultAudio;
                }
              }
              this.listActionSosData.push(obj);
            }
          }
        }
        else {
          this.listActionSosData = [];
          if (res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              let item = res.data[i];
              let obj = {
                date: item.gpsTS,
                employeeName: item.employeeName,
                empID: item.empID,
                isMobile: item.isMobile,
                lat: +parseFloat(item.lat).toFixed(5),
                lng: +parseFloat(item.lng).toFixed(5),
                location: item.near,
                orgID: item.org,
                sosID: item.sosID,
                sosAudio: item.sosAudio,
                type: item.type,
                vehId: item.regNo,
              };
              if (obj['sosAudio'] && obj['sosAudio'].length > 0) {
                for (let i = 0; i < obj['sosAudio'].length; i++) {
                  let resultAudio = await this.s3AudioService.s3GetAudio(obj['sosAudio'][i]);
                  obj['sosAudio'][i] = resultAudio;
                }
              }
              this.listActionSosData.push(obj);
            }
          }
        }
        this.actionTakenCount = res.count['ActionTaken'] ? res.count['ActionTaken'] : 0;
        this.pendingActionCount = res.count['Pending'] ? res.count['Pending'] : 0;
        this.tableShow = true; 
        setTimeout(()=>{ this.sosData = [ ...this.listActionSosData]; this.noDataFoundEnable = true; },1000);
      }
    }).catch((err) => {
      console.log(err)
    })
  }

  changeTableView(type) {
    this.tableShow = false;
    this.activeTable = type;
    this.getSOSActionList();
  }

  different_hours(dt2, dt1) {
    let date1 = new Date(dt1);
    let date2 = new Date(dt2);
    var difference = (date2.getTime() - date1.getTime()) / 1000;
    difference /= (60 * 60);
    return Math.abs(Math.round(difference));

  }

  fieldChange(e) {
    this.currentDate = new Date();
    this.filterTimeStamp;
    if (e == 'today') {
      this.filterTimeStamp = new Date(this.currentDate).setHours(0, 0, 0);
    }
    else if (e == 'lastWeek') {
      let day = this.currentDate.getDay();
      let diff = this.currentDate.getDate() - day;
      let setDate = new Date(this.currentDate).setDate(diff);
      this.filterTimeStamp = new Date(setDate).setHours(0, 0, 0);
    }
    else if (e == 'lastMonth') {
      let setDate = new Date(this.currentDate).setDate(1);
      this.filterTimeStamp = new Date(setDate).setHours(0, 0, 0);
    }
    else {
      this.filterTimeStamp = 0;
    }
    this.filterTableData();
  }

  filterDateWise() {
    if (this.listActionSosData.length > 0)
      this.listActionSosData = this.listActionSosData.filter((e) => e.date > this.filterTimeStamp);
  }

  filterTableData() {
    let value = this.searchedValue;
    if (value == '') this.listActionSosData = [...this.sosData];
    else {
      this.listActionSosData = [];
      this.sosData.filter((item: any) => {
        // console.log(item[filterKey].includes(key))
        if (item['vehId'].toLowerCase().includes(value.toLowerCase())) {
          this.listActionSosData.push(item);
        }
      });
    }
    this.filterDateWise();
  }

  /*   getActionCount(type){
      let actionTakenCount = 0;
      let pendingActionCount = 0;
        this.sosData.filter((e)=>{
          let IsActionMessage = e.hasOwnProperty('actionMessage');
          let IsActionTime = e.hasOwnProperty('actionTime');
          if (IsActionMessage || IsActionTime ) actionTakenCount++;
          else pendingActionCount++;
        });
      if (type == 'actionTaken') return actionTakenCount;
      if (type == 'pendingAction') return pendingActionCount;
    } */

  // table take action
  openTakeAction(sos) {
    this.sosID = sos.sosID;
    this.closeTakeAction = false;
  }

  reloadSosData() {

    this.sosID = undefined;
    this.closeTakeAction = true;
    this.tableShow = false;
    this.getSOSActionList();

  }

  async openSosInfo(sos) {
    this.singleSosData = {};
    this.closeInfoPopup = true;

    let sosViewData: any = await this.getSOSViewData(sos.sosID);
    if (sosViewData && sosViewData.length > 0) {
      try {
        this.singleSosData = {
          sos: { ...sos },
          vehicle: { 
            vehRegNo: sosViewData[0]['vehRegNo'], 
            model: sosViewData[0]['model'], 
            make: sosViewData[0]['make'] 
          },
          vendor: {
            name: sosViewData[0]['vendorName'],
            mobile: sosViewData[0]['vendorMob'],
            vendorID: sosViewData[0]['vendorID']
          },
          driver: {
            name: sosViewData[0]['driverName'],
            mobile: sosViewData[0]['driverMob'],
            driverID: sosViewData[0]['driverID']
          },
        };
        if (sos.isMobile){
          this.singleSosData['employee'] = {
            name: sosViewData[0]['empInfo'][0]['name'],
            empRefID: sosViewData[0]['empInfo'][0]['empRefID'],
            profile: sosViewData[0]['empInfo'][0]['profile'],
            mobile: sosViewData[0]['empInfo'][0]['mobile'],
            employeeID: sosViewData[0]['empInfo'][0]['employeeID'],
          };
        }
      } catch (err) {
        console.log('Sos Panel Error', err)
      }
    }


    // if (this.singleSosData['sos'] && this.singleSosData['sos']['sosAudio'] && this.singleSosData['sos']['sosAudio'].length > 0) {
    //   for (let i = 0; i < this.singleSosData['sos']['sosAudio'].length; i++) {
    //     let resultAudio = await this.s3AudioService.s3GetAudio(this.singleSosData['sos']['sosAudio'][i]);
    //     this.singleSosData['sos']['sosAudio'][i] = resultAudio;
    //   }
    // }
    setTimeout(() => { this.closeInfoPopup = false; }, 300);

  }
  closeSosInfo(event) {
    console.log(event);
  }

  getSOSViewData(sosID) {
    return new Promise((resolve, rej) => {
      try {
        this.api.getSOSViewData({ sosID }).then((res: any) => {
          if (res.status == 'success') {
            if (res.data) resolve(res.data);
            else resolve([]);
          }
          else resolve([]);
        })
        //  res()
      } catch (error) {
        rej([])
      }
    })
  }

  async exportToExcel() {
    let headers = [];
    let data = [];
    this.excelData = {};
    let finalColumn = 'E2';
    //  console.log('list action sos data',this.listActionSosData);
    if (this.activeTable == 'pendingAction') {
      headers = ['S No', 'SOS type', 'Employee name', 'Reg no', 'SOS time'];
      data = this.listActionSosData.map((e, i) => {
        let empName = '---';
        if (e.employeeName) empName = e.employeeName;
        let type = (e.isMobile) ? 'Employee' : 'Vehicle';
        return [i + 1, type, empName, e.vehId.toUpperCase(), formatDate(e.date, 'dd/MMM/yyyy hh:mm:ss a', 'en-In')]
      })

    }
    else if (this.activeTable == 'actionTaken') {
      finalColumn = 'G2'
      headers = ['S No', 'SOS type', 'Employee name', 'Reg no', 'SOS time', 'SOS action time', 'SOS action message'];
      data = this.listActionSosData.map((e, i) => {
        let empName = '---';
        if (e.employeeName) empName = e.employeeName;
        let type = (e.isMobile) ? 'Employee' : 'Vehicle';
        return [i + 1, type, empName, e.vehId.toUpperCase(), formatDate(e.date, 'dd-MM-yyyy hh:mm:ss a', 'en-In'), formatDate(e.actionTime, 'dd-MM-yyyy hh:mm:ss a', 'en-In'), e.actionMessage]
      })
    };
    let tableTitle = this.activeTable == 'pendingAction' ? 'Pending Action' : 'Action Taken';
    const excelInfo = {
      title: {
        title: `SOS ${tableTitle}`,
        font: { name: 'Corbel', family: 4, size: 16, underline: 'double', bold: true },
        mergeCells: `A1:${finalColumn}`,
      },
      header: {
        headers: headers,
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFFF00' },
          bgColor: { argb: 'FF0000FF' }
        },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      },
      data: {
        data: data,
        columWith: [
          { colNo: 1, width: 7 },
          { colNo: 2, width: 20 },
          { colNo: 3, width: 20 },
          { colNo: 4, width: 25 },
          { colNo: 5, width: 25 },
          { colNo: 6, width: 25 },
          { colNo: 7, width: 25 },]
      }
    };
    // console.log('excel information', excelInfo);
    if (this.excelData[tableTitle] == undefined) { this.excelData[tableTitle] = {}; }
    this.swal.swalFunction("Success","Success","Please check your downloads", 2000);

    this.excelData[tableTitle] = excelInfo;

    const chunk: any = await this.comService.chunkObject(this.excelData, 50);
    for (let i = 0; i < chunk.length; i++) {
      this.excel.generateExcel(chunk[i], 'SOS_' + this.activeTable + '_' + i + '_' + new Date().getTime() + '.xlsx');
    }
    
   

    //this.excel.generateExcel(this.listActionSosData, `SOS_${this.activeTable}_` + new Date().getTime() + '.xlsx');
  }


}
